import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';
import BookingFlow from './pages/BookingFlow';
import Confirmation from './pages/Confirmation';
import Account from './pages/Account';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/search" element={<SearchResults data-id="element-8" />} data-id="element-7" />
            <Route path="/booking/:step" element={<BookingFlow data-id="element-10" />} data-id="element-9" />
            <Route path="/confirmation" element={<Confirmation data-id="element-12" />} data-id="element-11" />
            <Route path="/account" element={<Account data-id="element-14" />} data-id="element-13" />
          </Routes>
        </main>
        <Footer data-id="element-15" />
      </div>
    </BrowserRouter>;
}